import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'

export default async function loader() {
  return defer({
    data: mercuryApi.get('/pos/items'),
  })
}
